module.exports = __webpack_public_path__ + "media/images/new_culture/comments-2-cc501ebb041ba6d02936240e0611fe04.jpeg";